// This could probably be moved to a shared location for reuse elsewhere.
export abstract class FilterSettings<K> {
  abstract get(key: K): string[];
  abstract set(key: K, ...values: string[]): void;

  includes(key: K, value: string): boolean {
    return this.get(key).includes(value);
  }
  getOne(key: K): string | null {
    return this.get(key)[0] ?? null;
  }
  add(key: K, ...values: string[]): void {
    this.set(key, ...this.get(key), ...values);
  }
  remove(key: K, ...values: string[]): void {
    this.set(key, ...this.get(key).filter((v) => !values.includes(v)));
  }
  toggle(key: K, ...values: string[]): void {
    const currentValues = this.get(key);
    for (const value of values) {
      if (currentValues.includes(value)) {
        this.remove(key, value);
      } else {
        this.add(key, value);
      }
    }
  }
  clear(key: K): void {
    this.set(key);
  }
}
